/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SecReviewExceptionsOut
 */
export interface SecReviewExceptionsOut {
    /**
     * 
     * @type {string}
     * @memberof SecReviewExceptionsOut
     */
    detail: string;
}

/**
 * Check if a given object implements the SecReviewExceptionsOut interface.
 */
export function instanceOfSecReviewExceptionsOut(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "detail" in value;

    return isInstance;
}

export function SecReviewExceptionsOutFromJSON(json: any): SecReviewExceptionsOut {
    return SecReviewExceptionsOutFromJSONTyped(json, false);
}

export function SecReviewExceptionsOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecReviewExceptionsOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'detail': json['detail'],
    };
}

export function SecReviewExceptionsOutToJSON(value?: SecReviewExceptionsOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'detail': value.detail,
    };
}

